import { createFileRoute } from "@tanstack/react-router";
import { userQuery } from "@/api/mas";
import { profileQuery, wellKnownQuery } from "@/api/matrix";
import { EditUserContainer } from "@/features/users/edit/container";
import { userMessages } from "@/features/users/messages";
import { ensureParametersAreUlids } from "@/utils/parameters";

export const Route = createFileRoute("/_console/users_/$userId/edit")({
  staticData: { breadcrumb: { message: userMessages.editTitle } },
  loader: async ({ context: { queryClient, credentials }, params }) => {
    ensureParametersAreUlids(params);
    const { data: user } = await queryClient.ensureQueryData(
      userQuery(credentials.serverName, params.userId),
    );
    const wellKnown = await queryClient.ensureQueryData(
      wellKnownQuery(credentials.serverName),
    );
    const root = wellKnown["m.homeserver"].base_url;
    const username = user.attributes.username;
    const profile = await queryClient.fetchQuery(
      profileQuery(root, `@${username}:${credentials.serverName}`),
    );
    return { root, username, displayname: profile.displayname ?? "" };
  },
  component: EditUserPage,
});

function EditUserPage() {
  const { credentials } = Route.useRouteContext();
  const { userId } = Route.useParams();
  const data = Route.useLoaderData();
  return (
    <EditUserContainer
      key={userId}
      {...data}
      serverName={credentials.serverName}
      userId={userId}
    />
  );
}
